import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Link, graphql} from 'gatsby'

import Layout from '../components/Layout'
import Features from '../components/Features'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCloudDownloadAlt} from '@fortawesome/free-solid-svg-icons/faCloudDownloadAlt';
import {faGlobe} from '@fortawesome/free-solid-svg-icons/faGlobe';
import custom from '../../static/img/custom.svg';

export const IndexPageTemplate = ({
                                    image,
                                    title,
                                    heading,
                                    customized,
                                    mainpitch,
                                    description,
                                    intro,
                                  }) => {
  useEffect(() => window.ScrollReveal().reveal('.reveal'));

  return (
    <div>
      <div
        className="full-width-image margin-top-0"
        style={{
          backgroundImage: `url(${
            !!image.childImageSharp ? image.childImageSharp.fluid.src : image
          })`,
          backgroundPosition: `center 50vh`,
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: `inherit`,
          height: '100vh',
        }}
      >
        <div
          style={{
            lineHeight: '1',
            justifyContent: 'space-around',
            textAlign: 'center',
            overflow: 'auto'
          }}
        >
          <h1
            className="has-text-weight-bold is-size-3-mobile is-size-2-tablet is-size-1-widescreen reveal"
            style={{
              // backgroundColor: 'rgba(86, 75, 101, 0.6)',
              color: '#564b65',
              lineHeight: '1',
              padding: '0.5em 0.75em',
              visibility: 'hidden',
              marginBottom: '2rem',
              border: '4px solid #564b65'
            }}
          >
            {title}
          </h1>

          <div>
            <a href="https://github.com/alextselegidis/plainpad/releases/download/1.0.0-beta.4/plainpad-1.0.0-beta.4.zip" className="btn download" title="Self Hosted Package">
              <FontAwesomeIcon icon={faCloudDownloadAlt} />
              Download
            </a>
          </div>

          {/*<div>*/}
          {/*  <a href="standalone" className="btn download" title="Standalone Web App">*/}
          {/*    <FontAwesomeIcon icon={faGlobe} />*/}
          {/*    Standalone*/}
          {/*  </a>*/}
          {/*</div>*/}

          <div>
            <Link to="/standalone" className="btn download" title="Standalone Web App">
              <FontAwesomeIcon icon={faGlobe} />
              Standalone
            </Link>
          </div>
        </div>
      </div>

      <div className="promo">
        <div className="container">
          <h1>
            Book the free Plainpad Installation Service now and have the project maintainer install Plainpad on your
            own server for free!{' '}
            <a href="mailto:info@alextselegidis.com?subject=Plainpad%20Installation%20Service&body=I%20would%20like%20to%20book%20the%20Plainpad%20Installation%20Service">
              Drop a message to info@alextselegidis.com
            </a>
          </h1>
        </div>
      </div>

      <section className="section section--gradient">
        <div className="container">
          <div className="section">
            <div className="columns">
              <div className="column is-10 is-offset-1">
                <div className="content">
                  <div className="content" style={{
                    marginBottom: '4rem'
                  }}>
                    <div className="tile reveal">
                      <h1 className="title">{mainpitch.title}</h1>
                    </div>
                    <div className="tile reveal">
                      <p>{mainpitch.description}</p>
                    </div>
                  </div>
                  <div className="columns reveal">
                    <div className="column is-12">
                      <h3>
                        {heading}
                      </h3>
                      <p>{description}</p>
                    </div>
                  </div>
                  <Features gridItems={intro.blurbs}/>
                  <div className="columns">
                    <div className="column is-12 has-text-centered">
                      <Link className="btn reveal" to="/self-hosted">
                        More on features
                      </Link>
                    </div>
                  </div>
                  <div className="column is-12">
                    <img src={custom} className="illustration" alt="Customized Builds"/>

                    <h3>Customized Builds</h3>

                    <p>
                      Get the most out of Plainpad by opting for a customized build. Define the requirements and order a tailored solution
                      that completely suits your business needs.
                    </p>

                    <div className="has-text-centered">
                      <Link className="btn reveal" to="/customize">
                        Customize
                      </Link>
                    </div>
                  </div>
                  {/*<div className="column is-12">*/}
                  {/*  <h3>*/}
                  {/*    Latest stories*/}
                  {/*  </h3>*/}
                  {/*  <BlogRoll/>*/}
                  {/*  <div className="column is-12 has-text-centered">*/}
                  {/*    <Link className="btn" to="/blog">*/}
                  {/*      Read more*/}
                  {/*    </Link>*/}
                  {/*  </div>*/}
                  {/*</div>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

IndexPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  heading: PropTypes.string,
  mainpitch: PropTypes.object,
  description: PropTypes.string,
  intro: PropTypes.shape({
    blurbs: PropTypes.array,
  }),
}

const IndexPage = ({data}) => {
  const {frontmatter} = data.markdownRemark

  return (
    <Layout>
      <IndexPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        heading={frontmatter.heading}
        subheading={frontmatter.subheading}
        mainpitch={frontmatter.mainpitch}
        description={frontmatter.description}
        intro={frontmatter.intro}
      />
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default IndexPage

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        image {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        heading
        mainpitch {
          title
          description
        }
        description
        intro {
          blurbs {
            image {
              childImageSharp {
                fluid(maxWidth: 240, quality: 64) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            text
          }
        }
      }
    }
  }
`
